import React from "react";
import {
    Backdrop,
    Box,
    Button,
    Fade,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    Stack,
    Switch,
    FormControlLabel,
    TextField,
    Toolbar,
    Typography
} from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: { xs: 'unset', xl: '50%' },
    left: { xs: 0, xl: '50%' },
    right: { xs: 0 },
    bottom: { xs: 0 },
    transform: { xs: 'none', xl: 'translate(-50%, -50%)' },
    width: { sx: 700 },
    maxWidth: { xs: 'unset' },
    bgcolor: 'background.paper',
    border: '2px solid #555',
    boxShadow: 24,
    borderRadius: { xs: 0, xl: '10px' },
    p: 4,
};

const providerOptions = [
    { value: 1, label: 'Umod' },
    { value: 2, label: 'Oxide-russia.ru' },
    { value: 3, label: 'Codefling' },
    { value: 4, label: 'Moscow.ovh' },
    { value: 5, label: 'Topplugin.ru' },
];

const ProviderSelect = ({ value, onChange, labelId = 'select-provider' }) => (
    <FormControl fullWidth>
        <InputLabel id={labelId}>Источник</InputLabel>
        <Select labelId={labelId} value={value} label="Источник" onChange={e => onChange(e.target.value)}>
            {providerOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
        </Select>
    </FormControl>
);

export const AddPluginModal = ({ open, onClose, form, onFormChange, onSubmit }) => (
    <Modal open={open} onClose={onClose} closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }}>
        <Fade in={open}>
            <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">Добавить плагин</Typography>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <Box sx={{ p: 2 }}>
                        <Stack sx={{ mt: 2 }} spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap">
                            <FormControl sx={{ width: { xs: '100%' }, flex: { lg: 1 } }}>
                                <ProviderSelect value={form.provider} onChange={(value) => onFormChange('provider', value)} />
                            </FormControl>
                            <FormControl sx={{ width: { xs: '100%' }, flex: { lg: 1 } }}>
                                <TextField variant="outlined" label="Наименование" value={form.name ?? ''} onChange={e => onFormChange('name', e.target.value)} />
                            </FormControl>
                        </Stack>
                        <Stack sx={{ mt: 2 }} spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap">
                            <FormControl sx={{ width: { xs: '100%' }, flex: { lg: 1 } }}>
                                <TextField variant="outlined" label="Версия" value={form.version ?? ''} onChange={e => onFormChange('version', e.target.value)} />
                            </FormControl>
                            <FormControl sx={{ width: { xs: '100%' }, flex: { lg: 1 } }}>
                                <TextField variant="outlined" label="" type="file" onChange={e => onFormChange('file', e.target.files[0])} />
                            </FormControl>
                        </Stack>
                        <FormControlLabel
                            sx={{ mt: 1 }}
                            control={<Switch checked={Boolean(form.visible)} onChange={e => onFormChange('visible', e.target.checked)} />}
                            label="Показывать плагин игрокам"
                        />
                    </Box>
                    <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 2, sm: 2 } }}>
                        <Button variant="contained" onClick={onSubmit} color="primary" sx={{ width: { xs: '100%', sm: '25ch' }, marginLeft: 'auto' }} type="submit">Сохранить</Button>
                    </Toolbar>
                </Box>
            </Box>
        </Fade>
    </Modal>
);

export const EditPluginModal = ({ open, onClose, form, onFormChange, onSubmit }) => (
    <Modal open={open} onClose={onClose} closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }}>
        <Fade in={open}>
            <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">Управление плагином</Typography>
                <Box sx={{ width: '100%', typography: 'body1', mt: 2 }}>
                    <Stack spacing={2}>
                        <ProviderSelect value={form.provider} onChange={(value) => onFormChange('provider', value)} labelId="edit-provider" />
                        <TextField fullWidth label="Наименование" variant="outlined" value={form.name ?? ''} onChange={e => onFormChange('name', e.target.value)} />
                        <TextField fullWidth label="Версия" variant="outlined" value={form.version ?? ''} onChange={e => onFormChange('version', e.target.value)} />
                        <FormControlLabel control={<Switch checked={Boolean(form.visible)} onChange={e => onFormChange('visible', e.target.checked)} />} label="Показывать плагин игрокам" />
                        <Button variant="outlined" component="label">
                            Загрузить файл
                            <input hidden type="file" onChange={e => onFormChange('file', e.target.files[0])} />
                        </Button>
                        <Button variant="contained" onClick={onSubmit}>Сохранить</Button>
                    </Stack>
                </Box>
            </Box>
        </Fade>
    </Modal>
);
